import React from "react";

const AboutUs = () => {
	return (
		<div className="aboutusWrapper">
			<div className="gd"></div>
			<div className="aboutus-container default-container default-container-height">
				<div className="about-astron">
					<div className="about-astron-image">
						<img src="/astron web icon/about-us.png" alt="" />
					</div>
					<div className="about-astron-content">
						<h5>ABOUT US</h5>
						<p>Astron maths Academy was founded in 2008 with the motive to help students by engaging them with ancient mathematical learning experience.</p>
						<p>Moreover, learning Vedic Mathematics strengthens their calculation skills and elevate love for the subject.</p>
						<p>Many young learners have math phobia and dislike the subject and hence result in poor grades. In spite of mathematics being a scoring subject students fail to learn the subject.</p>
						<p>Now, here Vedic Maths come to the rescue, learning Vedic Mathematics at Astron Maths Academy with plenty of mind developing games and puzzles which actually help the students to like the subject.</p>
						<p>The Courses designed at Astron Maths Academy are child - centric course which means the child will learn at his or her own speed which assures you 100% improvement.</p>
					</div>
				</div>

				<div className="gd"></div>
				<div className="astron-hr"></div>
				<div className="gd"></div>

				<div className="about-vedic">
					<div className="about-vedic-image">
						<img src="/astron web icon/about-vedic-maths.png" alt="" />
					</div>
					<div className="about-vedic-content">
						<h5>ABOUT VEDIC MATHS</h5>
						<p>
							Vedic maths is the world's fastest calculating system discovered by Jagadguru Shankaracharya Sri Bharti Krishna Tirthji during 1884-1960. It is derived from ancient Vedas particularly from Atharva Veda.
						</p>
						<p>It comprises of 16 sutras or formulae. These formulas are intended to describe the way the mind naturally works and are therefore supposed to be a great help in directing the students to the appropriate method of solution.</p>
						<p>The whole Vedic Mathematics is interrelated and unified : the general multiplication method, for example is easily reverse to allow one line division and the simple squaring method can be reversed to give one line square roots. And, these are all easily understood.</p>
						<p>This unified quality is very satisfying, it makes calculation easy and enjoyable and it encourages innovation too. Difficult Arithmetic problem and huge sums can often be solved immediately by Vedic Mathematics.</p>
					</div>
				</div>

				<div className="gd"></div>

				<div className="about-vedicbenifits-content">
					<h5>Benifits of Vedic Maths</h5>
					<p>It is 15 to 20 times faster than normal maths.</p>
					<p>Increases mental calculation and concentration.</p>
					<p>Improve intelligent, guessing analytical, thinking and logical thinking.</p>
					<p>Improve Academic performance with Holistic development.</p>
					<p>Increases Imagination power and Confidence of a student.</p>
					<p>It reduces Maths phobia.</p>
				</div>

				<div className="gd"></div>
				<div className="astron-hr"></div>
				<div className="gd"></div>

				<div className="vedic-abacus">
					<h5 className="title">Difference between Vedic Math & Abacus</h5>
					<div className="table-grid">
						<div className="diff-header">
							<h5>Vedic Maths</h5>
							<h5>Abacus</h5>
						</div>
						<div className="diff-content">
							<p>Derived from Atharva Veda</p>
							<p>Based on Chinese or Japanese Abacus</p>
						</div>
						<div className="diff-content">
							<p>One doesn't needs to learn any kind of instrument.</p>
							<p>One needs to learn an instrument i.e. Abacus to calculate.</p>
						</div>
						<div className="diff-content">
							<p>One can do addition, subtraction, multiplication, division, square, square root, Cube, cube roots, algebra, linear equation simultaneous equation, geometry and anything.</p>
							<p>One can do addition subtraction multiplication and division only.</p>
						</div>
						<div className="diff-content">
							<p>Courses available up to competitive exam level. From age 8 to 85 anybody can learn Vedic Maths.</p>
							<p>No courses available for class 7th onwards.</p>
						</div>
					</div>
				</div>
			</div>
			<div className="gd"></div>
		</div>
	);
};

export default AboutUs;
